import script from "./ExecuteExercise.vue?vue&type=script&setup=true&lang=js"
export * from "./ExecuteExercise.vue?vue&type=script&setup=true&lang=js"

import "./ExecuteExercise.vue?vue&type=style&index=0&id=4218a38f&scoped=true&lang=css"
import "./ExecuteExercise.vue?vue&type=style&index=1&id=4218a38f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4218a38f"]])

export default __exports__